const SIZE_MAP = {
  xl: { fontSize: 56, lineHeight: '56px' },
  l:  { fontSize: 40, lineHeight: '44px' },
};

export default function Display({ size = 'xl', as: Tag = 'h1', children, style, ...rest }) {
  return (
    <Tag
      style={{
        fontFamily: 'var(--font-display)',
        fontWeight: 400,
        textTransform: 'uppercase',
        letterSpacing: '0.01em',
        color: 'var(--text-primary)',
        ...SIZE_MAP[size],
        ...style,
      }}
      {...rest}
    >
      {children}
    </Tag>
  );
}
